export const NetfrontServices = {
  BONOBO: 'BONOBO',
  EKARDO: 'EKARDO',
  HOWLER: 'HOWLER',
  MURIQUI: 'MURIQUI',
  VERVET: 'VERVET',
  CAPUCHIN: 'CAPUCHIN',
  TRIPLEE: 'TRIPLE_E',
};
